import { Link, Outlet } from "react-router";
import { useAuth } from "@clerk/react";
import { ArrowLeft } from "lucide-react";
import { SkipLink } from "@/components/layout/SkipLink";
import { PublicFooter } from "@/components/layout/PublicFooter";
import { Button } from "@/components/ui/button";

/** Shell for pages without a signed-in shell: sign in, sign up, invite, help, not found. */
export function PublicLayout() {
  // Help, legal and verify pages are public, but a signed-in user reaches them from the app
  // and needs a way back that is not the browser's back button. "/" lands them on their dashboard.
  const { isSignedIn } = useAuth();
  return (
    <div className="bg-background flex min-h-dvh flex-col">
      <SkipLink />
      <header className="border-border flex items-center justify-between gap-4 border-b px-4 py-4 sm:px-6">
        <Link to="/" className="hover:text-primary text-lg font-semibold">
          HourSign
        </Link>
        {isSignedIn && (
          <Button asChild variant="outline" size="sm">
            <Link to="/">
              <ArrowLeft aria-hidden="true" />
              Back to dashboard
            </Link>
          </Button>
        )}
      </header>
      {/* 40rem suits a sign-in form. A page that shows a table asks for more with data-wide.
          data-help is wider again: the Help Center puts a topic list beside a 68ch article. */}
      <main
        id="main"
        className="mx-auto w-full max-w-[40rem] flex-1 px-4 py-8 has-[[data-help]]:max-w-[68rem] has-[[data-wide]]:max-w-[50rem] sm:px-6"
      >
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
